import { useMutation } from '@tanstack/react-query';
import { POST, POST_CANCEL_WARRANTY } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';

export const useDelReg = ({ onSuccessCallBack }) => {
  const mutation = useMutation({
    mutationFn: async ({ warrantyId, remark }) => {
      const response = await POST(POST_CANCEL_WARRANTY(), { warrantyId, remark });
      onSuccessCallBack?.(response);
      return response;
    },
    onSuccess: () =>
      openAlert({ model: 'message', type: 'success', message: 'ลบข้อมูลรายการลงทะเบียนสำเร็จ' }),
  });

  return { mutate: mutation.mutate, loading: mutation.isPending };
};
